import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import {
  OBSERVATION_MAX_LENGTH,
  observationReasonSchema,
  type ObservationReasonFormData,
} from "@/schemas/procedures/observation-reason";
import { Button, TextAreaField } from "@elaniintc/goes-design-system";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

interface Props {
  isOpen: boolean;
  defaultReason?: string;
  onClose: () => void;
  onAccept: (val: { description: string }) => void;
}

const DenyReasonShowModal = ({
  isOpen,
  defaultReason,
  onClose,
  onAccept,
}: Props) => {
  const { register, watch, handleSubmit } = useForm<ObservationReasonFormData>({
    resolver: zodResolver(observationReasonSchema),
    defaultValues: {
      reason: defaultReason || "",
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [reason] = watch(["reason"]);

  const onSubmit = async (data: ObservationReasonFormData) => {
    onAccept({
      description: data.reason,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Comentario de observación"
      description="Motivo de observación del campo para que el usuario pueda corregir sus datos."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <form
        className="flex flex-col gap-6"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(onSubmit)(e);
        }}
        id="edit-role-form"
      >
        <TextAreaField
          label="¿Por qué observa este campo?"
          required
          placeholder="Escribe tu comentario..."
          className="relative h-[88px] max-h-[88px]"
          disabled
          {...register("reason")}
          limit={OBSERVATION_MAX_LENGTH}
          count={reason?.length || 0}
        />
        <DialogFooter className="pt-1">
          <div className="w-full ">
            <Button
              size="lg"
              type="button"
              className="w-full rounded-lg"
              variant="tertiary"
              onClick={onClose}
            >
              Aceptar
            </Button>
          </div>
        </DialogFooter>
      </form>
    </Modal>
  );
};

export default DenyReasonShowModal;
